(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('controlSusController', controlSusController);


        controlSusController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'notificationService', 'logEmpleadosService', 'common', 'userService', 'simpleModalService', 'empleadosService'
    ];


    function controlSusController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, notificationService, logEmpleadosService, common, userService, simpleModalService, empleadosService) {

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.searchText = ""; 
        vm.totalSelected = 0;
        vm.changes = false; 
        vm.subActiva = false; 
        vm.subId = null; 
        vm.guardando = false; 

        vm.slider = {
            value: 5,
            options: {
                id: 'slider', 
                onEnd: function(id) {
                        vm.changes = true;
                }, 
                floor: 5,
                ceil: 100, 
                readOnly: false, 
                showSelectionBar: true,
                getSelectionBarColor: function(value) {
                    if(vm.totalSelected <= value) return 'green'; 
                    if(vm.totalSelected > value) return 'red'; 
                }
            }
        };


        vm.precioEmpleado = 2.50; 
        vm.fechaContratado = null; 
        vm.active = []; //empleados con jornada abierta

        vm.customFilter = customFilter;
        vm.toggleEmpleado = toggleEmpleado; 
        vm.selectAll = selectAll; 
        vm.servicioActivado = userService.userData.empresamaster.contrataControlHorario == true; 
        vm.save = save; 
        vm.openList = openList; 
        vm.changeActivado = changeActivado; 
        vm.supervisores = {
            list: [], 
            selected: {}
        };


        (function () {
            loadData();
        })();


        function loadData() {
            vm.guardando = false; 
            logEmpleadosService.getAllEmpleados().then(function (response) {
                vm.empleados = response;
                vm.totalSelected = 0; 
                for(var i = 0; i < vm.empleados.length; i++) {
                    if(vm.empleados[i].activarControlHorario == true) {
                        vm.empleados[i].selected = true;
                        vm.totalSelected++; 
                    }
                    else {
                        vm.empleados[i].selected = false; 
                    }
                }
                logEmpleadosService.getZoho(userService.userData.empresaMasterId).then(function(res) {
                    var idx = res.items.findIndex(x=> (x.planCode == 'ESTANDAR_RRHH_MEN' || x.planCode == 'BASICO_RRHH_MEN') && (x.status == 'trial' || x.status == 'live'));
                    if(idx != -1) {
                        vm.subActiva = true; 
                        vm.subId = res.items[idx].subscriptionId; 
                        vm.slider.value = res.items[idx].employeeCount; 
                        vm.servicioActivado = true; 
                        vm.fechaContratado = moment(res.items[idx].activationDate).format("DD-MM-YYYY");
                    } 
                    else {
                        vm.subActiva = false; 
                        vm.slider.value = 5; 
                        vm.servicioActivado = false; 
                    }
                    vm.slider.options.ceil = vm.empleados.length; 
                    vm.slider.options.readOnly = !vm.servicioActivado; 
                    $scope.$broadcast('rzSliderForceRender');
                }); 
                vm.empleados.sort(compare); 
                vm.changes = false;
            });
            empleadosService.getSupervisores().then(function(res) {
                vm.supervisores.list = res; 
                vm.supervisores.selected = vm.supervisores.list[0]; 
            });
        }

        function customFilter(item) {
            if(item.apellidos == null) item.apellidos = ""; 
            if(item.nombre == null) item.nombre = ""; 
            var bool = false;
            if (vm.searchText == "") bool = true;
            else if (item.apellidos.toLowerCase().includes(vm.searchText) || item.nombre.toLowerCase().includes(vm.searchText)) {
                bool = true;
            } 
            return bool;
        }
          
        function toggleEmpleado(item) {
            vm.changes = true; 
            var bool = vm.totalSelected > vm.slider.value; 
           if(item.selected == true) {
               item.selected = false; 
               vm.totalSelected--; 
           }
           else {
               item.selected = true; 
               vm.totalSelected++; 
           }
           if ((vm.totalSelected > vm.slider.value) != bool) $scope.$broadcast('rzSliderForceRender');
           vm.empleados.sort(compare); 
        }

        function selectAll() {
            vm.changes = true;
            var select = vm.empleados.length != vm.totalSelected; 
            for(var i = 0; i < vm.empleados.length; i++) {
                vm.empleados[i].selected = select; 
            }
            vm.totalSelected = select == true ? vm.empleados.length : 0; 
            $scope.$broadcast('rzSliderForceRender');
        }
        
        function afterCheckings(list) {
            if(vm.subActiva == false && vm.servicioActivado == true) {
                logEmpleadosService.createZoho(userService.userData.empresaMasterId, vm.slider.value).then(function(res) {
                    if(res.hasError) {
                        vm.guardando = false; 
                        sendErrorRequire(res.errorMessages.toString());
                    }
                    else {
                        afterZoho(list); 
                    }
                });
            }
            else if(vm.subActiva == true && vm.servicioActivado == true) {
                logEmpleadosService.updateZoho(vm.subId, vm.slider.value).then(function(res) {
                    if(res.hasError) {
                        vm.guardando = false; 
                        sendErrorRequire(res.errorMessages.toString());
                    }
                    else {
                        afterZoho(list); 
                    } 
                });
            }
            else if(vm.subActiva == true && vm.servicioActivado == false) {
                logEmpleadosService.deleteZoho(vm.subId).then(function(res) {
                    if(res.hasError) {
                        vm.guardando = false; 
                        sendErrorRequire(res.errorMessages.toString());
                    }
                    else {
                        afterZoho(list); 
                    }
                });
            }
        }
        
        function afterZoho(list) {
            var bool = userService.userData.empresamaster.contrataControlHorario != vm.servicioActivado;
            var supervisorId = vm.supervisores.selected.usuarioId; 
            logEmpleadosService.suscriptionHorarioUpdate(bool, list, vm.slider.value, supervisorId).then(function(response) {
                if (response.data == false) {
                    sendSaveNotification('El número de empleados seleccionados supera las licencias contratadas');
                    loadData(); 
                } 
                else {
                    var msg = '';
                    if (vm.servicioActivado) {
                        msg = 'La suscripcion se ha guardado correctamente';
                    } else msg = 'La suscripcion se ha guardado correctamente y se ha desactivado el control horario de todos los empleados';
                    sendSaveNotification(msg);
                    userService.getUserData().then(function (response) {
                        loadData();
                    });
                }
                vm.guardando = false; 
            });
        }

        function save() {
            if(vm.guardando == true) return; 
            vm.guardando = true; 
            if(checkErrorsOnSave()) {
                var list = [];
                var listCheckings = ""; 
                for (var i = 0; i < vm.empleados.length; i++) {
                    if (vm.empleados[i].activarControlHorario != vm.empleados[i].selected) {
                        list.push({
                            id: vm.empleados[i].empleadoId,
                            accion: vm.empleados[i].selected
                        });
                        if(vm.empleados[i].selected == false && vm.empleados[i].registroJornadaId != null) {
                            if (listCheckings != "") listCheckings += ', ' + vm.empleados[i].nombre + vm.empleados[i].apellidos
                            else listCheckings += vm.empleados[i].nombre + vm.empleados[i].apellidos;
                        }
                    }
                }
                if(listCheckings != "") {
                    listCheckings += ' tienen jornadas activas, si procede se eliminarán. ¿Está de acuerdo?';
                      simpleModalService
                          .yesNoModal('Confirmación desactivar', listCheckings) // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                          .then(function (result) { 
                             if(result) {
                                  afterCheckings(list); 
                             }
                             else {
                                 vm.guardando = false; 
                                 return
                             }; 
                          });
                }
                else {
                    afterCheckings(list); 
                }
           
            }
            else vm.guardando = false; 
        }

        function changeActivado() {
            if(vm.servicioActivado == false) {
                 simpleModalService.yesNoModal('Desactivar control horario', 
                 'Si desactiva el control horario se puede borrar la información relacionada a este, ¿está seguro?')
                     .then(function (result) {
                         if (result) {
                             vm.slider.options.readOnly = true;
                             vm.changes = true;
                             $scope.$broadcast('rzSliderForceRender');
                         }
                         else {
                             vm.servicioActivado = true; 
                         }
                     });
            }
            else {

                vm.slider.options.readOnly = false;
                $scope.$broadcast('rzSliderForceRender');
            }
        }

        function sendSaveNotification(msg) {
            notificationService.sendAppNotification({
                message: msg,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'info'
            });
        }

        function checkErrorsOnSave() {
            //  if (vm.fechaContratado != null && vm.servicioActivado == true && userService.userData.empresamaster.contrataControlHorario == false) {
            //      sendErrorRequire('Ya activó antes el control horario, por favor póngase en contacto con Investel.');
            //      return false;
            //  }
             if(vm.totalSelected > vm.slider.value && vm.servicioActivado == true) {
                  sendErrorRequire('Tiene más empleados seleccionados que licencias contratadas');
                  return false;
             }
             if(userService.userData.esAdmin == false) {
                 sendErrorRequire('No tiene permisos para modificar este plan');
                 return false;
             }
             return true; 
        }

        function sendErrorRequire(messageValue) {
            notificationService.sendAppNotification({
                message: messageValue,
                positionY: 'top',
                positionX: 'right',
                delay: 3000,
                type: 'error'
            });
        }

        function compare(a, b) {
            if(a.selected && !b.selected) return -1; 
            if(b.selected) return 1;
            return 0;
        }

        function openList(e) {
            $(e.currentTarget).siblings("div").toggle();
            e.stopPropagation();
        }

    }
})();
